import { Link } from 'react-router-dom';
import { navCategories } from '@/mocks/home';

interface CategoryHeroProps {
  name: string;
  description: string;
  image: string;
  slug: string;
}

export default function CategoryHero({ name, description, image, slug }: CategoryHeroProps) {
  const currentIndex = navCategories.findIndex((c) => c.slug === slug);
  const prev = currentIndex > 0 ? navCategories[currentIndex - 1] : navCategories[navCategories.length - 1];
  const next = currentIndex < navCategories.length - 1 ? navCategories[currentIndex + 1] : navCategories[0];

  return (
    <section className="relative w-full pt-24 md:pt-32 pb-10 md:pb-16">
      <div className="w-full px-6 md:px-10 max-w-6xl mx-auto flex flex-col items-center">
        <div className="flex items-center gap-2 mb-4">
          <span className="px-3 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-full font-label">
            {name}
          </span>
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
        </div>
        <h1 className="text-4xl md:text-7xl font-heading font-bold text-foreground-950 text-center leading-tight">
          {name}<br />
          <span className="text-foreground-300">独家爆料</span>
        </h1>
        <p className="mt-4 md:mt-6 text-sm md:text-base text-foreground-600 text-center max-w-lg leading-relaxed">{description}</p>
        <div className="flex items-center gap-3 mt-6 md:mt-8">
          <Link to={`/category/${prev.slug}`} className="flex items-center gap-1.5 px-5 py-2.5 text-sm font-medium text-foreground-600 hover:text-foreground-950 border border-foreground-200 hover:border-foreground-400 rounded-full transition-colors duration-200 whitespace-nowrap font-label">
            <i className="ri-arrow-left-line text-xs"></i>{prev.name}
          </Link>
          <Link to={`/category/${next.slug}`} className="flex items-center gap-1.5 px-5 py-2.5 bg-foreground-950 text-background-50 text-sm font-medium rounded-full hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap font-label">
            {next.name}<i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
      </div>
      <div className="w-full px-6 md:px-10 max-w-6xl mx-auto mt-10 md:mt-14">
        <div className="relative w-full rounded-2xl overflow-hidden" style={{ aspectRatio: '16/7' as string }}>
          <img src={image} alt={`51黑料吃瓜网 - ${name}分类`} title={`51黑料吃瓜网 - ${name}`} className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/15 to-transparent"></div>
        </div>
      </div>
    </section>
  );
}